import { render, staticRenderFns } from "./EmploymentDialog.vue?vue&type=template&id=24fd670a&"
import script from "./EmploymentDialog.vue?vue&type=script&lang=ts&"
export * from "./EmploymentDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports